import api from '../../utils/api';

export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData);
  return response.data.data;
};

export const fetchMyOrders = async (params) => {
  const response = await api.get('/orders/my-orders', { params });
  return response.data.data;
};

export const fetchOrderById = async (orderId) => {
  const response = await api.get(`/orders/${orderId}`);
  return response.data.data;
};

export const trackOrder = async (orderNumber) => {
  const response = await api.get(`/orders/track/${orderNumber}`);
  return response.data.data;
};

export const cancelOrder = async (orderId, reason) => {
  const response = await api.post(`/orders/${orderId}/cancel`, { cancelReason: reason });
  return response.data.data;
};

export const requestReturn = async (orderId, returnData) => {
  const response = await api.post(`/orders/${orderId}/return-request`, {
    returnReason: returnData?.reason || returnData?.returnReason || '',
  });
  return response.data.data;
};
